module.exports = __webpack_public_path__ + "static/media/telephoneLogo.319d45b4.png";